'use client';

import { useEffect, type FC } from 'react';
import { getApiBaseUrl } from '../../utils/apiBaseUrl';
import {
  NEWS_VIEW_MEMORY,
  createNewsSessionId,
  registerNewsView,
  scheduleNewsView,
  type NewsViewBody,
  type NewsViewStorage,
} from './newsViewCounter';

const sessionStorageOrNull = (): NewsViewStorage | null => {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
};

// WHY: fetch, а не sendBeacon — бэкенд требует заголовок X-Requested-With от CSRF, а sendBeacon заголовков не ставит
const postNewsView = (body: NewsViewBody): Promise<Response> =>
  fetch(`${getApiBaseUrl()}/api/news/views`, {
    method: 'POST',
    keepalive: true,
    credentials: 'omit',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'shot' },
    body: JSON.stringify(body),
  });

export const NewsViewBeacon: FC<{ articleId: string; enabled: boolean }> = ({ articleId, enabled }) => {
  useEffect(() => {
    if (!enabled) return;
    return scheduleNewsView(window, () => {
      void registerNewsView(articleId, enabled, {
        storage: sessionStorageOrNull(),
        memory: NEWS_VIEW_MEMORY,
        createId: () => createNewsSessionId(crypto),
        post: postNewsView,
      });
    });
  }, [articleId, enabled]);

  return null;
};
